import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  selector: 'app-services-container',
  imports: [CommonModule,RouterModule],
  standalone: true,
  templateUrl: './services-container.component.html',
  styleUrl: './services-container.component.scss'
})
export class ServicesContainerComponent {

}
